import classNames from "classnames";
import { Avatar } from "d-react-components";

const UserAvatarName = ({
  user,
  placeholder = "N/A",
  size = "x-small",
  className = "",
  variant = "rounded",
  text = "",
}: any) => {
  if (!user || !user?.id) return placeholder;
  return (
    <div className={classNames("flex-center-y cursor-pointer", className)}>
      <Avatar src={user?.avatar} size={size} variant={variant} />
      <div className="ml-2 ">
        {text || `${user?.fullname}`}
        <div className="small text-muted">{`ID: (${user?.companyId})`}</div>
      </div>
    </div>
  );
};

export default UserAvatarName;
